<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              barPercentage:0.7,
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  
    props:{
        chartProp: Object
    },
  mounted() {
    this.renderChart(
      {
        labels: this.chartProp.label,
        datasets: [
          {
            label: "Income",
            // borderColor: "#F36F2E",
            pointBackgroundColor: "white",
            borderRadius: 10,
            borderWidth: 1,
            width: '30px',
            pointBorderColor: "white",
            backgroundColor: "#0A84FF",
            data: this.chartProp.income, 
          },
          {
            label: "Outcome",
            // borderColor: "#F36F2E",
            pointBackgroundColor: "white",
            borderRadius: 10,
            borderWidth: 1,
            width: '30px',
            pointBorderColor: "white",
            backgroundColor: "#ffa500",
            data: this.chartProp.outcome,
          },
        ],
      },
      this.options,
      { responsive: true, maintainAspectRatio: false }
    );
  },
  watch: {
    chartProp(newData) {
      this.renderChart(
        {
        labels: newData.label,
        datasets: [
          {
            label: "Income",
            // borderColor: "#F36F2E",
            pointBackgroundColor: "white",
            borderRadius: 10,
            borderWidth: 1,
            width: '30px',
            pointBorderColor: "white",
            backgroundColor: "#0A84FF",
            data: newData.income, 
          },
          {
            label: "Outcome",
            // borderColor: "#F36F2E",
            pointBackgroundColor: "white",
            borderRadius: 10,
            borderWidth: 1,
            width: '30px',
            pointBorderColor: "white",
            backgroundColor: "#ffa500",
            data: newData.outcome,
          },
        ],
      },
      this.options,
      { responsive: true, maintainAspectRatio: false }
      );
    } 
  }
};
</script>
